import { render } from "./HeroEvent.vue?vue&type=template&id=59aef29a&scoped=true&ts=true"
import script from "./HeroEvent.vue?vue&type=script&lang=ts"
export * from "./HeroEvent.vue?vue&type=script&lang=ts"

import "./HeroEvent.vue?vue&type=style&index=0&id=59aef29a&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59aef29a"]])

export default __exports__